import { z } from 'zod';

export const careRequirementsSchema = z.array(z.number());
